import { IPField } from './p-field.interface';
import { injectValueAccessor } from '@panaya/ui/p-value-accessor';
import { Component, Output } from '@angular/core';

@Component({ template: '' })
export abstract class PFieldBase<TValue> implements IPField<TValue> {
    protected readonly valueAccessor = injectValueAccessor<TValue>();

    @Output() public readonly viewValueChanged = this.valueAccessor.viewValueChanged;
    /**
     * @deprecated Please use {@link viewValueChanged} instead.
     */
    @Output() public readonly valueChange = this.valueAccessor.viewValueChanged;

    public setValue(value: TValue): void {
        this.valueAccessor.setValue(value);
    }
}
